import { getVertexId } from '../../core/util';
import type { CoreTypes } from '../../core';
import type { Types as SduiTypes } from '../types';

export default (
  location: CoreTypes.Mixed.Location,
  options:  SduiTypes.options
): SduiTypes.room => {
  return {
    id:   getVertexId(location, options),
    name: location.displayName,
  };
};